import { Link } from "gatsby";
import Logo from "images/logo_menu.svg";
import IcoSearch from "images/search.svg";
import * as React from "react";
import { useLoc } from "../../hooks/useLoc";
import { Burger } from "../shared/base/burger";
import { Modal } from "../shared/base/modal";
import { useStickyHeader } from "./hooks/useStickyHeader";
import { MobileMenu } from "./menu";
import { SearchSelect } from "./search";
import { TemperatureUnitPicker } from "./unit-picker";

export const Header = ({ noFadedEdge = true }: { noFadedEdge?: boolean }) => {
    const [isHover, setIsHovered] = React.useState(false);
    const [menuActive, setMenuActive] = React.useState(false);
    const [searchActive, setSearchActive] = React.useState(false);
    const headerRef = React.useRef(null);
    //const { showHeader, showFadedEdge } = useStickyHeader(headerRef, isHover);
    const showHeader = true;
    const showFadedEdge = false;
    const loc = useLoc();
    return (
        <header
            className={`fixed z-[500] h-[62px] w-full bg-white pb-1.5 shadow-sm shadow-black/30 transition-[top] duration-300 md:h-[80px] 
            ${showHeader ? "top-0" : "top-[-120px]"}  ${
                showFadedEdge && !noFadedEdge && "md:header-fade md:shadow-none"
            }`}
            ref={headerRef}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <div className="flex h-full w-full items-center">
                <Link to="/" className="mx-4 md:mx-[28px]">
                    <div className="flex items-center">
                        <img
                            src={Logo}
                            alt="Sunheron logo"
                            className="h-[36px] w-[36px] transition duration-300 md:h-[40px] md:w-[40px]"
                        />
                        <span className="relative top-0.5 mx-[16px] text-[24px] font-bold tracking-wide md:top-0 md:mx-[28px] md:text-[36px]">
                            Sunheron
                        </span>
                    </div>
                </Link>
                <Link
                    to="/about-us/"
                    className="mx-[24px] pt-[12px] text-[14px] tracking-widest mdmax:hidden"
                >
                    {loc("header.aboutSunheron")}
                </Link>
                <Link
                    to="/faq/"
                    className="mx-[24px] pt-[12px] text-[14px] tracking-widest mdmax:hidden"
                >
                    {loc("header.FAQ")}
                </Link>
                <Link
                    to="/contact/"
                    className="mx-[24px] pt-[12px] text-[14px] tracking-widest mdmax:hidden"
                >
                    {loc("header.contact")}
                </Link>
                <Link
                    to="/blog/"
                    className="mx-[24px] pt-[12px] text-[14px] tracking-widest mdmax:hidden"
                >
                    {"Blog"}
                </Link>
                <div className="flex-1"></div>
                <div className="ml-[24px] mdmax:hidden">
                    <SearchSelect isMobile={false} />
                </div>
                <div className="mx-[24px] w-28 min-w-[106px] text-center lgmax:mx-[16px] mdmax:hidden">
                    <TemperatureUnitPicker />
                </div>
                {!menuActive && (
                    <button
                        onClick={() => {
                            setSearchActive(!searchActive);
                        }}
                        className="relative top-[6px] mx-[12px] flex flex-col items-center text-center md:hidden xsmax:mx-[8px]"
                    >
                        <img
                            src={IcoSearch}
                            className="h-[18px] w-[18px]"
                        ></img>
                        <span className="text-[12px]">
                            {searchActive
                                ? loc("common.close").toUpperCase()
                                : loc("common.search").toUpperCase()}
                        </span>
                    </button>
                )}
                {!searchActive && (
                    <button
                        onClick={() => {
                            setMenuActive(!menuActive);
                        }}
                        className="relative top-[6px] mx-[12px] flex flex-col items-center text-center md:hidden"
                    >
                        <Burger></Burger>
                        <span className="text-[12px]">
                            {menuActive
                                ? loc("common.close").toUpperCase()
                                : loc("common.menu").toUpperCase()}
                        </span>
                    </button>
                )}
            </div>
            <Modal active={menuActive}>
                <MobileMenu />
            </Modal>
            <Modal active={searchActive}>
                {/* strange bug, when both React selects are rendered, there are problems with focus */}
                {searchActive && (
                    <div className="w-full px-8">
                        <div className="h-4"></div>
                        <SearchSelect isMobile={true}></SearchSelect>
                    </div>
                )}
            </Modal>
        </header>
    );
};
